export default __webpack_public_path__ + "static/media/JP.4ecbd30a.svg";